import { render, staticRenderFns } from "./SendMessageModal.vue?vue&type=template&id=004c2578&scoped=true&"
import script from "./SendMessageModal.vue?vue&type=script&lang=js&"
export * from "./SendMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004c2578",
  null
  
)

export default component.exports